import MercuryNewsDashboardView from "src/sections/dashboards/platforms/mercury-news/mercury-news-dashboard-view";

const MercuryNewsCustomDashboardPage = () => <MercuryNewsDashboardView type="custom" />;

export default MercuryNewsCustomDashboardPage;
